<div class="containers" *ngIf="(orders$ | async)!.length > 0">
    <div class="info_cards">
        <div class="info_card">
            <div class="top_info_card">
                <img class="position_right" src="assets/icones/arrow-bottom (2).svg" alt="">
                <span class="size_weight_color1">{{"quotations_and_orders.total_orderations_Requested"| translate}}</span>
                <span class="size_weight_color2 pr-15">{{"common.this_month"| translate}}</span>
            </div>
            <span class="size_weight_color3">{{ (kpi$ | async)?.total_requested ?? 0 | number }}</span>
        </div>
        <div class="info_card">
            <div class="top_info_card">
                <img class="position_right" src="assets/icones/arrow-bottom (2).svg" alt="">
                <span class="size_weight_color1">{{"quotations_and_orders.average_orderations_Requested"| translate}}</span>
                <span class="size_weight_color2 pr-15">{{"common.this_month"| translate}}</span>
            </div>
            <span class="size_weight_color3">{{ (kpi$ | async)?.average_requested ?? 0 | number }}</span>
        </div>
        <div class="info_card">
            <div class="top_info_card">
                <img class="position_right" src="assets/icones/arrow-bottom (2).svg" alt="">
                <span class="size_weight_color1">{{"quotations_and_orders.average_response_time"| translate}}</span>
                <span class="size_weight_color2 pr-15">{{"common.this_month"| translate}}</span>
            </div>
            <span class="size_weight_color3">{{ formatResponseTime((kpi$ | async)?.average_response_time ?? 0) }}</span>
        </div>
    </div>
    <div class="right_container">
        <div class="page_container">
            <table class="listing_table">
                <thead class="header_stiky">
                    <tr class="head_table">
                        <th>
                           {{"quotations_and_orders.id_order"| translate}}
                           <div class="sort-actions">
                            <span class="arrow-up" [class.active]="activeSortBy == 'name' && activeSortMode == 'asc'" (click)="sortBy('name', 'asc')"></span>
                            <span class="arrow-down" [class.active]="activeSortBy == 'name' && activeSortMode == 'desc'" (click)="sortBy('name', 'desc')"></span>
                          </div>
                        </th>
                        <th>
                          {{"common.date_time"| translate}}
                          <div class="sort-actions">
                            <span class="arrow-up" [class.active]="activeSortBy == 'date_order' && activeSortMode == 'asc'" (click)="sortBy('date_order', 'asc')"></span>
                            <span class="arrow-down" [class.active]="activeSortBy == 'date_order' && activeSortMode == 'desc'" (click)="sortBy('date_order', 'desc')"></span>
                          </div>
                        </th>
                        <th style="display: block;">
                            <span>{{"quotations_and_orders.company"| translate}}</span><br />
                            <span class="gray">{{"common.contact"|translate}} ({{"common.email"| translate}})</span>
                        </th>
                        <th>{{"Catalogs.catalog_name"| translate}}</th>
                        <th class="people-col">{{"quotations_and_orders.order_creator_col"| translate}}</th>
                        <th class="people-col">{{"quotations_and_orders.order_owner_col"| translate}}</th>
                        <th class="number_clmn">
                          {{"quotations_and_orders.items"| translate}}
                          <div class="sort-actions">
                            <span class="arrow-up" [class.active]="activeSortBy == 'total_lines' && activeSortMode == 'asc'" (click)="sortBy('total_lines', 'asc')"></span>
                            <span class="arrow-down" [class.active]="activeSortBy == 'total_lines' && activeSortMode == 'desc'" (click)="sortBy('total_lines', 'desc')"></span>
                          </div>
                        </th>
                        <th class="number_clmn">
                          {{"quotations_and_orders.total_price"| translate}}
                          <div class="sort-actions">
                            <span class="arrow-up" [class.active]="activeSortBy == 'amount_total' && activeSortMode == 'asc'" (click)="sortBy('amount_total', 'asc')"></span>
                            <span class="arrow-down" [class.active]="activeSortBy == 'amount_total' && activeSortMode == 'desc'" (click)="sortBy('amount_total', 'desc')"></span>
                          </div>
                        </th>
                        <th>{{"common.status"| translate}}</th>
                    </tr>
                </thead>
                <tbody class="scrollable-body-orders">
                    <ng-container *ngFor="let order of displayOrders$ | async">
                        <tr
                            *ngIf="order.ato_processing_status === 'processing'"
                            class="body_table body_table--processing"
                        >
                            <td class="ato-row__mark">
                                <span class="volta-pulse ato-row__sparkle">
                                    <app-svg-icon svgIcon="sparkle"></app-svg-icon>
                                </span>
                            </td>
                            <td>
                                <span class="volta-skel ato-skel--type"></span>
                            </td>
                            <td class="td_block">
                                <div class="ato-sender">
                                    <span class="ato-sender__avatar">
                                        <app-svg-icon svgIcon="at-sign"></app-svg-icon>
                                    </span>
                                    <span class="ato-sender__text">
                                        <span class="ato-sender__email">{{ order.ato_sender_email }}</span>
                                        <span class="ato-sender__subject">{{ order.ato_email_subject }}</span>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <span class="volta-skel ato-skel--catalog"></span>
                            </td>
                            <td>
                                <span class="volta-skel ato-skel--creator"></span>
                            </td>
                            <td>
                                <span class="volta-skel ato-skel--creator"></span>
                            </td>
                            <td class="number_clmn">
                                <span class="volta-skel ato-skel--qty"></span>
                            </td>
                            <td class="number_clmn">
                                <span class="volta-skel ato-skel--price"></span>
                            </td>
                            <td>
                                <span class="ato-pill ato-pill--processing">
                                    <span class="volta-pulse ato-pill__dot"></span>
                                    <span>{{ 'orders.processing.label' | translate }}</span>
                                    <span class="ato-pill__elapsed">· {{ elapsedFor(order.processing_started_at) }}</span>
                                </span>
                            </td>
                        </tr>

                        <tr
                            *ngIf="order.ato_processing_status === 'needs_review'"
                            class="body_table body_table--error"
                        >
                            <td class="ato-row__mark">
                                <span class="ato-row__alert">
                                    <app-svg-icon svgIcon="alert-circle-red"></app-svg-icon>
                                </span>
                            </td>
                            <td class="td_block">
                                <div class="ato-sender">
                                    <span class="ato-sender__avatar ato-sender__avatar--error">
                                        <app-svg-icon svgIcon="at-sign"></app-svg-icon>
                                    </span>
                                    <span class="ato-sender__text">
                                        <span class="ato-sender__email">{{ order.ato_sender_email }}</span>
                                        <span class="ato-sender__subject">{{ order.ato_email_subject }}</span>
                                    </span>
                                </div>
                            </td>
                            <td class="ato-error">
                                <span
                                    class="ato-error__reason"
                                    tooltip=""
                                    [tooltipTemplate]="reasonTooltip"
                                    [center]="true"
                                    [maxWidth]="'320px'"
                                    (click)="$event.stopPropagation()"
                                >
                                    <span class="ato-pill ato-pill--error">
                                        {{ order | reviewReason: 'label' | translate }}
                                    </span>
                                    <app-svg-icon class="ato-error__info" svgIcon="info"></app-svg-icon>
                                </span>
                                <ng-template #reasonTooltip>
                                    <div class="ato-error-tooltip">
                                        <span class="ato-error-tooltip__title">
                                            {{ order | reviewReason: 'label' | translate }}
                                        </span>
                                        <span class="ato-error-tooltip__text">
                                            {{ order | reviewReason: 'detail' | translate }}
                                        </span>
                                    </div>
                                </ng-template>
                                <span class="ato-error__spacer"></span>
                                <div class="ato-error__actions">
                                    <button
                                        type="button"
                                        class="ato-btn ato-btn--create"
                                        (click)="createManually(); $event.stopPropagation()"
                                    >
                                        <app-svg-icon svgIcon="plus"></app-svg-icon>
                                        {{ 'orders.processing.create_manually' | translate }}
                                    </button>
                                    <button
                                        type="button"
                                        class="ato-btn ato-btn--delete"
                                        (click)="deleteProcessingRow(order); $event.stopPropagation()"
                                    >
                                        <app-svg-icon svgIcon="Trash"></app-svg-icon>
                                        {{ 'orders.processing.delete' | translate }}
                                    </button>
                                </div>
                            </td>
                        </tr>

                        <tr
                            *ngIf="order.ato_processing_status !== 'processing' && order.ato_processing_status !== 'needs_review'"
                            class="body_table hover_tr"
                            (click)="details(order)"
                        >
                            <td>
                                {{order.name}}
                            </td>
                            <td>
                                <div class="head_sapn_inline">
                                    <span class="bold">{{order.date_order | adaptToUserUtcOffset | date: DATE_FORMAT}}</span> <br>
                                </div>
                            </td>
                            <td class="td_block description_cell cursor">
                                <span class="bold">{{order.location_name}}</span>
                                <br/>
                                <span class="descr_elemnt">{{order.location_email}}</span>
                            </td>
                            <td>
                                {{order.pricelist_name}}
                            </td>
                            <td class="td_people" (click)="$event.stopPropagation()">
                                <span class="list-user-chip" *ngIf="order.order_creator as c">
                                  <span class="list-user-avatar">{{ userInitials(c.name) }}</span>
                                  <span class="list-user-text">{{ c.name }}</span>
                                </span>
                                <span *ngIf="!order.order_creator" class="list-user-empty">—</span>
                            </td>
                            <td class="td_people" (click)="$event.stopPropagation()">
                                <span class="list-user-chip list-user-chip-owner" *ngIf="order.owner as o">
                                  <span class="list-user-avatar">{{ userInitials(o.name) }}</span>
                                  <span class="list-user-text">{{ o.name }}</span>
                                </span>
                                <span *ngIf="!order.owner" class="list-user-empty">—</span>
                            </td>
                            <td class="number_clmn td-order-lines" (click)="$event.stopPropagation()">
                                <button
                                    type="button"
                                    class="order-lines-trigger"
                                    [disabled]="!order.line_composition"
                                    [matTooltip]="'quotations_and_orders.line_composition.click_for_details' | translate"
                                    [matTooltipDisabled]="!order.line_composition"
                                    [matMenuTriggerFor]="orderLinesPopover.menu"
                                >
                                    <span class="order-lines-count">{{ orderLinesCount(order) }}</span>
                                    <span class="order-lines-label">{{ (orderLinesCount(order) === 1 ? "quotations_and_orders.item" : "quotations_and_orders.items") | translate | lowercase }}</span>
                                    <span class="order-lines-badge" *ngIf="attentionCount(order) as attention">{{ attention }}</span>
                                </button>
                                <app-line-composition-popover
                                    #orderLinesPopover
                                    [composition]="order.line_composition"
                                    [orderName]="order.name"
                                ></app-line-composition-popover>
                            </td>
                            <td class="number_clmn">
                                <span class="bold">{{order.amount_total | number:'1.2-2'}}€</span>
                            </td>
                            <td>
                            <span class="tag" [ngStyle]="order.order_status ? getStatusStyles(order.order_status) : {}">
                                {{ order.order_status ? getStatusTranslation(order.order_status) : '' }}
                            </span>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
            <app-pagination [pagination]="pagination$ | async" (toPageEvent)="toPage($event)"></app-pagination>
        </div>
    </div>
</div>
<div *ngIf="filter && (orders$ | async)!.length === 0  && !(isAppLoading$ | async)" class="no_reseult">
    <ng-container *ngIf="filter?.filters!.length === 0 && !key">
      <img class="no_intense" src="../../../../../assets/icones/no-orders.svg" alt="">
      <h3>{{"quotations_and_orders.no_orders" | translate}}</h3>
    </ng-container>
    <ng-container *ngIf="filter?.filters!.length > 0 || key">
      <img class="no_intense" src="../../../../../assets/icones/no-result-search.svg" alt="">
      <h3>{{"quotations_and_orders.no_orders_data_search" | translate }}</h3>
    </ng-container>
</div>
